<template>
  <button class="gmf-item-container" @click.stop="buy" :style="computedContainerStyle" :class="computedContainerClass" :aria-label="item.name + (bestPrice ? (' - ' + formattedPrice + ' coins') : '')">
    <div class="gmf-item" :class="darkClass">
      <div v-if="item.itemBrand && item.type !== 'item-bundle'" class="gmf-item-brand gmf-item-brand-top-left">
        <img :src="item.itemBrand.iconUrl" loading="lazy" draggable="false" />
      </div>
      <div v-if="selected" class="gmf-item-selected">
        <Icon icon="checkmark" />
      </div>
      <!-- Multiple or single color pill -->
      <div v-if="item.type === 'avatar-3d-part' && variationColors.length > 0" :class="variationColors.length == 1 ? 'gmf-list-item-color-pill' : 'gmf-list-item-color-pills'">
        <ColorPill v-for="color in variationColors.slice(0, 3)" :key="color.uuid" :colors="color" />
      </div>
      <div v-if="quantity > 1 && item.type != 'token'">
        <div class="gmf-item-quantity">{{ quantity }}</div>
      </div>

      <div
        :class="
          {
            'gmf-item-bundle-image': item.type === 'item-bundle',
            'gmf-item-loot-crate': item.type === 'loot-crate',
            'gmf-item-image': item.type !== 'item-bundle' && item.type !== 'loot-crate',
          }"
        :style="imageStyle"
        loading="lazy"
        draggable="false"
      >
        <div
          :style="newImageStyle"
          class="gmf-item-image-inner"
        />
      </div>

      <div :class="item.type === 'item-bundle' ? 'gmf-item-content-bundle' : 'gmf-item-content'" :style="textAlignStyle">
        <div v-if="item.itemBrand && item.type === 'item-bundle'" class="gmf-item-brand">
          <img :src="item.itemBrand.iconUrl" loading="lazy" draggable="false" />
        </div>
        <div class="gmf-item-pill gmf-text-small" v-if="limitedItem">
          {{ t('limited') }}
        </div>

        <template v-if="showName">
          <div>
            <div class="gmf-item-name">
              <template v-if="item.type == 'token' && quantity && ! item.name.includes('x')">
                {{ quantity }}
              </template>
              {{ item.name }}
            </div>
            <div class="gmf-text-small gmf-item-subtitle">{{ item.subtitle }}</div>
          </div> 
          <div v-if="item.description" class="gmf-text gmf-item-description">
            {{ item.description }}
          </div>
        </template>
        <!--<div class="gmf-item-info">
          <div v-if="categoryTranslation" class="gmf-item-info-category">{{ categoryTranslation }}</div>
          <div class="gmf-item-rarity-label" :style="rarityLabelStyle">{{ item.rarity }}</div>
        </div>-->
        <div v-if="! done && priceCountdown" class="gmf-item-price gmf-text-small">
          <Countdown :prefixString="t('available_in')" :unixTimestamp="priceCountdown" @done="done = true" />
        </div>
        <div class="gmf-item-price gmf-text-small" :key="item.uuid + index" v-if="item.type === 'loot-crate' &&  (! done && nextOpenTime > new Date().getTime().toString().slice(0, -3))">
          <Countdown :prefixString="t('available_in')" :unixTimestamp="nextOpenTime" @done="done = true" />
        </div>
        <div v-else-if="showPrice && bestPrice" class="gmf-item-price">
          <template v-if="itemIsOwned && showIfOwned">
            <Icon class="gmf-icon-purchased-checkmark" icon="checkmark" />
          </template>
          <template v-else-if="bestPrice.amount === 0">
            <span class="gmf-item-price-text gmf-subheader gmf-mb-0">{{ t('free') }}</span>
          </template>
          <template v-else>
            <img class="gmf-token" :src="bestPrice.token.icon" loading="lazy" draggable="false" />
            <span span class="gmf-item-price-text gmf-subheader gmf-mb-0">{{ bestPrice.amount }}</span>
          </template>
        </div>
        <ColorSelector v-if="hasColors && showColors" :colors="item.colors" v-model="selectedColor" />
      </div>
    </div>
  </button>
</template>
<style>
.gmf-item-container {
  position: relative;
  cursor: pointer;
  border-radius: var(--gmf-rounding);
  user-select: none;
  padding: unset;
  display: block;
  background: unset;
  width: 100%;
}

.gmf-item-container:hover {
  background: unset;
}

.gmf-item {
  position: relative;
  display: flex;
  flex-direction: column;
  background-color: var(--gmf-card-col-ongray);
  height: 100%;
  overflow: hidden;
  border-radius: var(--gmf-rounding);
}

/* Color selector */
.gmf-item .gmf-horizontal-pills-menu {
  padding: 0;
}

.gmf-item-price {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: var(--gmf-p-2);
}

.gmf-item-price-text {
  font-weight: bold !important;
  color: var(--gmf-col-black) !important;
  margin-top: 1px;
}

.gmf-item-price.gmf-disabled .gmf-item-price-text {
  opacity: 0.5;
}

.gmf-item-image-container {
  width: 100%;
  text-align: center;  line-height: 0;
  text-overflow: ellipsis;
  overflow: hidden;
}

.gmf-item-image {
  aspect-ratio: 1;
  width: 100%;
}

.gmf-item-bundle-image, .gmf-item-loot-crate {
  width: 100%;
  aspect-ratio: 1.77777777778;
  position: relative;
  z-index: 1;
  overflow: hidden;
}

.gmf-item-image-inner {
  width: 100%;
  height: 100%;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}

.gmf-item-loot-crate::before {
  content: "";
  position: absolute;
  width: 115%;
  aspect-ratio: 1;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: -1;
  opacity: 0.6;
  background-image: url(https://cdn.gamifiera.com/static/1/upl/wr7uzdN3BXio4RzU.webp);
  background-size: cover;
  background-position: center;
  animation: gmf-spinning 12s linear infinite;
}

@keyframes gmf-spinning {
  0% {
    transform: translate(-50%, -50%) rotate(0deg);
  }
  100% {
    transform: translate(-50%, -50%) rotate(360deg);
  }
}

.gmf-context .gmf-item-name {
  max-height: 36px;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  font-weight: bold;
  color: var(--gmf-col-black);
}

.gmf-item-content-bundle {
  display: flex;
  position: relative;
  flex-direction: column;
  padding: var(--gmf-p-3) var(--gmf-p-4);
  /* padding-top: var(--gmf-p-4); */
  flex-grow: 1;
  /* gap: calc(var(--gmf-p-2) + var(--gmf-p-1)); */
  justify-content: space-between;

}

.gmf-item-content {
  display: flex;
  position: relative;
  flex-direction: column;
  padding: var(--gmf-p-3) var(--gmf-p-4);
  /* padding-top: var(--gmf-p-3); */
  flex-grow: 1;
  /* gap: calc(var(--gmf-p-2) + var(--gmf-p-1)); */
  justify-content: center;
  position: relative;
}

.gmf-item-description {
  flex-grow: 1;
  margin-top: var(--gmf-p-3);
  margin-bottom: var(--gmf-p-2);
}

.gmf-item-countdown {
  position: absolute;
  top: var(--gmf-p-3);
  right: 0;
  padding: var(--gmf-p-1) var(--gmf-p-3);
  background-color: var(--gmf-col-white);
  border-radius: var(--gmf-rounding) 0 0 var(--gmf-rounding);
}

.gmf-item-info {
  display: flex;
  flex-direction: row;
  gap: var(--gmf-p-3);
  flex-wrap: nowrap;
  align-items: center;
}

.gmf-item-info-category {
  text-overflow: ellipsis;
  overflow: hidden;
}

.gmf-item .gmf-token-shop-color-selector {
  margin-top: var(--gmf-p-3);
}

.gmf-item-footer {
  display: flex;
  flex-direction: row;
  gap: var(--gmf-p-3);
  align-items: center;
  justify-content: space-between;
}

.gmf-icon-purchased-checkmark {
  filter: brightness(0);
  width: 24px;
  height: 24px;
}

.gmf-item-brand {
  z-index: 2;
  position: absolute;
  top: -9px;
  left: var(--gmf-p-4);
  color: var(--gmf-col-black);
  background-color: var(--gmf-col-white);
  border-radius: var(--gmf-rounding);
  overflow: visible;
  padding: var(--gmf-p-2);
  height: 18px;
  display: flex;
}

.gmf-item-brand-top-left {
  top: var(--gmf-p-3);
  left: var(--gmf-p-3);
}

.gmf-item-pill {
  position: absolute;
  right: var(--gmf-p-3);
  top: 0;
  transform: translateY(-50%);
  color: var(--gmf-col-black);
  background-color: var(--gmf-col-white);
  border-radius: 50px;
  padding: var(--gmf-p-2) var(--gmf-p-3);
  overflow: visible;
  z-index: 1;
}

.gmf-item-brand img {
  height: 100%;
  max-width: 35px;
}

.gmf-item-selected {
  display: flex;
  position: absolute;
  top: var(--gmf-p-2);
  right: var(--gmf-p-2);
  --gmf-icon-color: var(--gmf-col-black);
  background-color: var(--gmf-col-white);
  border-radius: 100%;
  padding: var(--gmf-p-1);
  z-index: 1;
  /*border: 2px solid var(--gmf-col-black);*/
}
.gmf-item-selected .gmf-icon {
  width: 20px;
  height: 20px;
}

.gmf-item .gmf-color-pill-radius {
  width: 15px;
  height: 15px;
}

.gmf-item-quantity {
  position: absolute;
  top: var(--gmf-p-2);
  right: var(--gmf-p-2);
  padding: var(--gmf-p-1);
  border-radius: var(--gmf-rounding);
  font-weight: bold;
  font-size: 12px;
  line-height: 1;

}

.gmf-item-rare::before {
  content: "";
  display: block;
  position: absolute;
  width: 100%;
  height: 100%;
  animation: rare 4s ease infinite;
  border-radius: var(--gmf-rounding);
  box-shadow: 0px 0px 8px var(--gmf-rarity-col-rare);
  background-color: var(--gmf-rarity-col-rare);
}

@keyframes rare {
  0% {
    transform: scale(1.01);
  }
  50% {
    transform: scale(1.01);
  }
  100% {
    transform: scale(1.01);
  }
}

.gmf-item.gmf-dark {
  background: black;
}

.gmf-context .gmf-item-subtitle {
  color: var(--gmf-brand-color) !important;
}

.gmf-list-item-color-pills {
  display: flex;
  flex-direction: row;
  gap: var(--gmf-p-2);
  position: absolute;
  top: var(--gmf-p-4);
  right: var(--gmf-p-4);
}

.gmf-list-item-color-pill {
  position: absolute;
  top: var(--gmf-p-3);
  right: var(--gmf-p-3);
}
</style>
<script>
import { isItemOwned, getBestPrice } from './utils';
import state from '@/state';
import Icon from '../Icon.vue';
import callApi from '@/utils/callApi';
const t = state.t.prefix('token_shop');
import eventbus from '@/utils/eventbus';
const tl = state.t.prefix('loot_crates');
const ts = state.t.prefix('avatar.slots');
import ColorSelector from './ColorSelector.vue';
import formatVirtualCurrency from '@/utils/formatVirtualCurrency';
import showLootCrateRewards from '@/widgets/LootCrate/showLootCrateRewards';
import ColorPill from '@/components/AvatarConfigurator/colors/ColorPill.vue';
import Countdown from '@/widgets/LootCrate/Countdown.vue';

import { lootCrateStatus } from '../TokenShop/data.js';

export default {
  props: {
    item: {
      Type: Object,
    },
    canClick: {
      Type: Boolean,
      default: true,
    },
    horizontalLayout: {
      Type: Boolean,
      default: false,
    },
    showPrice: {
      Type: Boolean,
      default: true,
    },
    showColors: {
      Type: Boolean,
      default: false,
    },
    showName: {
      Type: Boolean,
      default: true,
    },
    showIfOwned: {
      Type: Boolean,
      default: true,
    },
    textAlign: {
      Type: String,
      default: 'center',
    },
    selected: {
      type: Boolean,
      default: false,
    }
  },
  inject: {
    inventory: {
      default: () => null,
    },
  },
  data () {
    return {
      done: false,
      selectedColor: null,
      isLootCrateOpening: false,
      index: 0,
    }
  },
  beforeUnmount () {
    eventbus.off("refreshListItem", this.refreshItem);
  },
  created () {
    if (this.showColors && this.item.colors?.length > 0) {
      this.selectedColor = this.item.colors[0];
    }
    eventbus.on("refreshListItem", this.refreshItem);
  },
  computed: {
    quantity () {
      if (this.item.type === 'loot-crate') {
        return lootCrateStatus[this.item.typeName]?.quantity || 0;
      }

      return this.item.quantity || this.item.metadata?.quantity || 1;
    },
    textAlignStyle () {
      return {
        textAlign: this.textAlign,
      }
    },
    categoryTranslation () {
      if (this.item.type === 'avatar-3d-part') {
        return state.t.prefix('avatar.slots')(this.item.category.id);
      } else if (this.item.type === 'avatar-3d-color') {
        return state.t.prefix('avatar.colors')(this.item.category.id);
      } 
      return '';
    },
    computedContainerStyle () {
      const style = {};

      // const rarity = this.item.rarity || 'basic';

      if (this.rarity !== 'rare') {
        // style.boxShadow = `var(--gmf-rarity-col-border-${rarity})`;
      }

      return style;
    },
    itemIsOwned () {
      if (! this.inventory) {
        return false;
      }

      return isItemOwned(this.inventory, this.item);
    },
    colors () {
      return this.item.colors;
    },
    hasColors () {
      return this.colors?.length > 0;
    },
    rarity () {
      return this.item.rarity;
    },
    rarityLabelStyle () {
      return {
        backgroundColor: 'var(--gmf-rarity-col-' + this.rarity + ')',
      }
    },
    imageStyle () {
      const style = {};

      if (! this.rarity) {
        return style;
      }

      style.background = `linear-gradient(25deg, var(--gmf-rarity-col-gradient-${ this.rarity }-1) 0%, var(--gmf-rarity-col-gradient-${ this.rarity }-2) 80%, var(--gmf-rarity-col-gradient-${ this.rarity }-3) 100%)`;

      if (this.item.opacity) {
        style.opacity = this.item.opacity;
      }

      return style;
    },
    newImageStyle () {
      const style = {};

      if (this.previewUrl) {
        style.backgroundImage = `url(${this.previewUrl})`;
      }
      if (this.item.type === 'xp') {
        style.backgroundSize = 'contain';
      }

      return style;
    },
    computedContainerClass () {
      if (this.rarity === 'rare') {
        return 'gmf-item-rare';
      }
      
      return '';
    },
    previewUrl() {
      if (this.item.type === 'loot-crate') {
        return this.item.imageUrl || this.item.url;
      }
      if (this.item?.type === 'avatar-3d-part' || this.item?.type === 'avatar-3d-color') {
        if (this.item?.uuid) {
          if (this.displayColor) {
            return state.cdnBase + this.item.url + '/' + this.displayColor.uuid;
          }
          return state.cdnBase + this.item.url;
        }
        if (this.item?.url) {
          return this.item.url;
        }
        return '';
      }

      return this.item.url;
    },
    bestPrice () {
      this.done; // Make sure the price gets recomputed when the countdown has finished.
      return getBestPrice(this.item);
    },
    formattedPrice () {
      if (! this.bestPrice) {
        return '';
      }
      return formatVirtualCurrency(this.bestPrice.amount);
    },
    /**
     * Returns the color to display in the preview.
     */
    displayColor () {
      if (this.item.type === 'avatar-3d-part' && this.item.variation?.color) {
        return this.item.variation.color;
      }

      if (this.selectedColor) {
        return this.selectedColor;
      }

      return null;
    },
    darkClass () {
      return { 'gmf-dark': this.item.dark };
    },
    nextOpenTime () {
      this.index;
      if (this.item.type !== 'loot-crate') {
        return 0;
      }

      if (lootCrateStatus[this.item.typeName]) {
        return lootCrateStatus[this.item.typeName].nextOpenTime;
      }
      return 0;
    },
    variationColors () {
      if (! this.item) {
        return [];
      }
      if (this.item.variations?.colors) {
        return this.item.variations.colors;
      }
      if (this.item.variation?.color) {
        return [this.item.variation.color];
      }
      return [];
    },
    priceCountdown () {
      if (this.bestPrice || ! this.item.prices) {
        // If there is an active price or no prices, no need to show a countdown.
        return false;
      }

      for (const price of this.item.prices) {
        if (price.startsAt && new Date() < new Date(price.startsAt)) {
          return (new Date(price.startsAt).getTime() / 1000) + "";
        }
      }

      return false;
    },  
    limitedItem () {
      return this.item.prices?.some(o => o.endsAt && new Date() < new Date(o.endsAt));
    }
  },
  methods: {
    t,
    tl,
    ts,
    buy () {
      if (! this.canClick) {
        return;
      }
      eventbus.emit('checkout-item', { item: this.item, price: this.bestPrice, color: this.selectedColor });
    },
    async openLootCrate (item) {
      const type = item.metadata.quantity === 1 ? 'one' : 'multiple';
      this.isLootCrateOpening = true;

      const openTime = 2.5;
      const earliestRevealAt = Date.now() + Math.round(openTime * 1000);

      const res = await callApi('POST', '/v1/client/types/my-loot-crates/' + item.metadata.lootCrateTypeId + '/open');

      if (res.status === 401) {
        this.error = 'session_expired'
        return;
      } else if (res.status !== 200) {
        this.error = 'crate_not_found'
        return;
      }

      const resBody = await res.json();

      const now = Date.now();

      // Convert from item format to loot crate format.
      const crate = {
        label: item.name,
        typeName: item.metadata.lootCrateTypeId,
        imageUrl: item.url,
        openImageUrl: item.metadata.openUrl,
        quantity: item.metadata.quantity,
      };

      if (now >= earliestRevealAt) {
        const contents = resBody.contents || [];

        showLootCrateRewards(crate, { autoOpen: false, type, contents });

        // @TODO check what event does.
        eventbus.emit('openedLootCrate');
      } else {
        setTimeout(() => {
          const contents = resBody.contents || [];

          showLootCrateRewards(crate, { autoOpen: false, type, contents });

          eventbus.emit('openedLootCrate');
        }, earliestRevealAt - now);
      }
    },
    refreshItem(uuid) {
      if (this.item.uuid == uuid) {
        this.done = false;
        this.$nextTick(() => {
          this.index++;
        });
      }
    }
  },
  components: {
    ColorSelector,
    Icon,
    ColorPill,
    Countdown
  }
};
</script>
